// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"d5c02b9c","960":"49d8e8a6"}[chunkId] + ".chunk.js";
};